// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "./StyleConstants.bs.js";
import * as Tokens from "@sothebys/sterling/tokens";

var focus_0 = Css.outline(Css.px(2), "none", Css.hex(SterlingTokens$LiveRoom.Colors.alertTurq60_nohashtag));

var focus_1 = {
  hd: Css.outlineOffset(Css.px(4)),
  tl: {
    hd: Css.unsafe("outlineStyle", "auto"),
    tl: /* [] */0
  }
};

var focus = {
  hd: focus_0,
  tl: focus_1
};

var buttonFocus_0 = Css.outline(Css.px(2), "none", Css.hex(SterlingTokens$LiveRoom.Colors.alertTurq60_nohashtag));

var buttonFocus_1 = {
  hd: Css.outlineOffset(Css.px(1)),
  tl: {
    hd: Css.unsafe("outlineStyle", "auto"),
    tl: /* [] */0
  }
};

var buttonFocus = {
  hd: buttonFocus_0,
  tl: buttonFocus_1
};

function mediaV2(media, style) {
  switch (media) {
    case /* Desktop */0 :
        return Css.media(StyleConstants$LiveRoom.Breakpoint.desktop, style);
    case /* Mobile */1 :
        return Css.media(StyleConstants$LiveRoom.Breakpoint.mobile, style);
    case /* TabletPortraitAndMobile */2 :
        return Css.media(StyleConstants$LiveRoom.Breakpoint.tabletPortrait, style);
    case /* MobileAndTablet */3 :
        return Css.media(StyleConstants$LiveRoom.Breakpoint.mobileAndTablet, style);
    case /* DesktopAndTabletLandscape */4 :
        return Css.media(StyleConstants$LiveRoom.Breakpoint.desktopAndTabletLandscape, style);
    
  }
}

function htmlContentStyle(defaultFontSize, defaultLineHeight) {
  return Curry._1(Css.style, {
              hd: Css.fontSize(Css.px(defaultFontSize)),
              tl: {
                hd: Css.lineHeight(Css.px(defaultLineHeight)),
                tl: {
                  hd: Css.fontFamily({
                        NAME: "custom",
                        VAL: Tokens.FontFamily.bentonSans
                      }),
                  tl: {
                    hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlack_nohashtag)),
                    tl: {
                      hd: Css.selector(" a", {
                            hd: Css.fontWeight({
                                  NAME: "num",
                                  VAL: 400
                                }),
                            tl: {
                              hd: Css.textDecoration("none"),
                              tl: {
                                hd: Css.visited({
                                      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
                                      tl: /* [] */0
                                    }),
                                tl: {
                                  hd: Css.hover({
                                        hd: Css.borderBottom(Css.px(1), Css.solid, Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
                                        tl: /* [] */0
                                      }),
                                  tl: {
                                    hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }),
                      tl: {
                        hd: Css.selector(" strong", {
                              hd: Css.fontWeight({
                                    NAME: "num",
                                    VAL: 600
                                  }),
                              tl: /* [] */0
                            }),
                        tl: {
                          hd: Css.selector(" em", {
                                hd: Css.fontStyle(Css.italic),
                                tl: /* [] */0
                              }),
                          tl: {
                            hd: Css.selector(" u", {
                                  hd: Css.textDecoration(Css.underline),
                                  tl: /* [] */0
                                }),
                            tl: {
                              hd: Css.selector(" sub", {
                                    hd: Css.verticalAlign(Css.sub),
                                    tl: {
                                      hd: Css.fontSize(Css.pct(75)),
                                      tl: /* [] */0
                                    }
                                  }),
                              tl: {
                                hd: Css.selector(" sup", {
                                      hd: Css.verticalAlign(Css.$$super),
                                      tl: {
                                        hd: Css.fontSize(Css.pct(75)),
                                        tl: /* [] */0
                                      }
                                    }),
                                tl: {
                                  hd: Css.selector(" ul", {
                                        hd: Css.listStyle("disc", "inside", "none"),
                                        tl: /* [] */0
                                      }),
                                  tl: {
                                    hd: Css.selector(" ol", {
                                          hd: Css.listStyle("decimal", "inside", "none"),
                                          tl: /* [] */0
                                        }),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

export {
  focus ,
  buttonFocus ,
  mediaV2 ,
  htmlContentStyle ,
}
/* focus Not a pure module */
